import React from "react";
import { StyleSheet, css } from "aphrodite";
import MooshooSorryImage from "../../assets/care-screener/mooshoo-sorry.png";
import useCareScreenerWidth from "../../hooks/care-screener/useCareScreenerWidth";
import Flex from "../core/Flex";
import Text from "../core/Text";
import Span from "../core/Span";
import AppStoreDownloadButtons from "../core/AppStoreDownloadButtons";

export default function EvernorthIneligible() {
  const { widthStyle } = useCareScreenerWidth();

  return (
    <Flex center className={css(styles.container)} style={widthStyle}>
      <div className={css(styles.card)}>
        <div className={css(styles.illustrationContainer)}>
          <img src={MooshooSorryImage} className={css(styles.manateeImage)} alt="Sad manatee" />
        </div>

        <Text
          size={smallScreen ? 28 : 32}
          weight={700}
          theme="manaBlueDark"
          center
          style={{ marginBottom: 20, lineHeight: 1.2 }}
        >
          We're sorry.
        </Text>

        <Text
          size={smallScreen ? 16 : 18}
          weight={700}
          theme="manaBlueDark"
          center
          style={{ marginBottom: 25, lineHeight: 1.4 }}
        >
          Based on the information provided, you're not eligible for this Cigna Healthcare program.
        </Text>

        <Text size={14} center style={{ marginBottom: 25, lineHeight: 1.5 }}>
          Please check the policyholder information and contact{" "}
          <a href="mailto:care@getmanatee.com">
            <Span theme="manaBlue" weight={600} style={{ textDecoration: "underline" }}>
              care@getmanatee.com
            </Span>
          </a>{" "}
          if you think there's been an error or have questions.
        </Text>

        <Text size={14} center style={{ marginBottom: 30, lineHeight: 1.5 }}>
          You can still download the free Manatee app 📱 for parenting tips, self-guided courses, and self-care
          resources.
        </Text>

        <div className={css(styles.downloadButtonsContainer)}>
          <AppStoreDownloadButtons
            badgeHeight={25}
            showApple={true}
            showGooglePlay={false}
            className={css(styles.downloadButton)}
          />
          <AppStoreDownloadButtons
            badgeHeight={25}
            showApple={false}
            showGooglePlay={true}
            className={css(styles.downloadButton)}
          />
        </div>
      </div>
    </Flex>
  );
}

const smallScreen = window.innerWidth < 768;

const styles = StyleSheet.create({
  container: {
    minHeight: "100vh",
    padding: "20px",
    position: "relative"
  },
  card: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: "40px 30px",
    maxWidth: smallScreen ? "90vw" : "500px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
    position: "relative",
    zIndex: 1
  },
  illustrationContainer: {
    position: "relative",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  manateeImage: {
    width: "120px",
    height: "120px",
    objectFit: "contain"
  },
  downloadButtonsContainer: {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    flexWrap: "nowrap",
    marginTop: "10px",
    alignItems: "center",
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden"
  },
  downloadButton: {
    margin: "0",
    display: "inline-block",
    flexShrink: 1,
    maxWidth: "calc(50% - 4px)",
    width: "auto"
  }
});
